import { render, staticRenderFns } from "./ReportcardandCbt.vue?vue&type=template&id=6116d093"
import script from "./ReportcardandCbt.vue?vue&type=script&lang=js"
export * from "./ReportcardandCbt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports